import { Button, styled } from '@mui/material';

export const OtpButton = styled(Button)({
  color: 'white',
  py: 1.2,
  borderRadius: 7,
  mb: 2,
  background: '#33408e',
  '&:hover': {
    background: '#2a357a',
  },
  '&.Mui-disabled': {
    color: 'white',
    background: '#b0b5cc',
  },
  textTransform: 'none',
  width: 280,
});
